import IGlobalState from '@/interfaces/IGlobalState';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { Marker, Map, LayerGroup } from 'leaflet';
import { Router } from 'vue-router';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import { IModalData } from '@/services/layers/IModalData';
import { IOpenWeather } from '@/interfaces/IOpenWeather';
import IPoiCategory from '@/interfaces/IPoiCategory';
import { IEventCategory } from "@/interfaces/IEventCategory";
import { ILinkElement } from '@/interfaces/ILinkElement';
import { IArticleElement } from '@/interfaces/IArticleElement';

export default {
  // ogólne mutacje
  flipResizeFont(state: IGlobalState, payload: number): void {
    state.fontSize = payload;
  },
  toggleMobileMenu(state: IGlobalState): void {
    state.showMobileMenu = !state.showMobileMenu;
  },
  flipContrastActive(state: IGlobalState): void {
    state.contrast = !state.contrast;
  },
  flipLanguage(state: IGlobalState, payload: number): void {
    state.currentLang = payload;
  },
  setNavActiveTab(state: IGlobalState, payload: number|null): void {
    state.navActiveTab = payload;
  },
  setCurrentRoute(state: IGlobalState, payload: Router): void{
    state.currentRoute = payload;
  },
  flipDrawerActive(state: IGlobalState): void {
    state.drawerActive = !state.drawerActive;
  },
  updateDrawerActive(state: IGlobalState, payload: boolean): void {
    state.drawerActive = payload;
  },
  flipInfoDrawerActive(state: IGlobalState): void {
    state.infoDrawerActive = !state.infoDrawerActive;
  },
  updateInfoDrawerActive(state: IGlobalState, payload: boolean): void {
    state.infoDrawerActive = payload;
  },
  flipLocationMode(state: IGlobalState): void {
    state.modes.selectLocation = !state.modes.selectLocation;
  },
  endLocationMode(state: IGlobalState): void {
    state.modes.selectLocation = false;
  },
  updatePosition(state: IGlobalState, payload: {lat: number, lng: number}): void {
    state.position.lat = payload.lat;
    state.position.lng = payload.lng;
  },
  updateZoomFactor(state: IGlobalState, payload: number): void {
    state.zoomFactor = payload;
  },
  showOverlay(state: IGlobalState): void {
    state.modes.showOverlay = true;
  },
  hideOverlay(state: IGlobalState): void {
    state.modes.showOverlay = false;
  },
  // dane API
  updateTranslations(state: IGlobalState, payload: any): void {
    state.translations = payload;
  },
  updateSegmentsConfig(state: IGlobalState, payload: any): void {
    state.segmentsConfig = payload;
  },
  updateParkings(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkings = payload;
  },
  updateParkingZones(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingZones = payload;
  },
  updateParkingMeters(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingMeters = payload;
  },
  updateParkingBoards(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingBoards = payload;
  },
  updateParkingSpots(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingSpots = payload;
  },
  updateParkingGroups(state: IGlobalState, payload: IFeatureCollection): void {
    state.parkingGroups = payload;
  },
  updateTraffic(state: IGlobalState, payload: IFeatureCollection): void {
    state.traffic = payload;
  },
  updateTrafficPoints(state: IGlobalState, payload: IFeatureCollection): void {
    state.trafficPoints = payload;
  },
  updatePoiLayers(state: IGlobalState, payload: Array<IPoiCategory>): void {
    state.poiLayers.layers = [...payload];
  },
  updatePoiPoints(state: IGlobalState, payload: IFeatureCollection): void {
    state.poiPoints = payload;
  },
  updateEvents(state: IGlobalState, payload: IFeatureCollection): void {
    state.events = payload;
  },
  updateEventCategories(state: IGlobalState, payload: Array<IEventCategory>): void {
    state.eventCategories = payload;
  },
  updateWeatherStations(state: IGlobalState, payload: IFeatureCollection): void {
    state.weatherStations = payload;
  },
  updateBikeStations(state: IGlobalState, payload: IFeatureCollection): void {
    state.bikeStations = payload;
  },
  updateVmsBoards(state: IGlobalState, payload: IFeatureCollection): void {
    state.vmsBoards = payload;
  },
  updateCameras(state: IGlobalState, payload: IFeatureCollection): void {
    state.cameras = payload;
  },
  updateTrackStartPoints(state: IGlobalState, payload: IFeatureCollection): void {
    state.trackStartPoints = payload;
  },
  updateTrackEndPoints(state: IGlobalState, payload: IFeatureCollection): void {
    state.trackEndPoints = payload;
  },
  updateTrackLines(state: IGlobalState, payload: Array<any>): void {
    state.trackLines = payload;
  },
  updateCurrentWeather(state: IGlobalState, payload: IWeatherStatus): void {
    state.currentWeather = payload;
  },
  updateOpenWeather(state: IGlobalState, payload: IOpenWeather): void {
    state.openWeather = payload;
  },
  // dane warstw
  updateUserPositionMarker(state: IGlobalState, payload: Marker): void {
    state.userPositionMarker = payload;
  },
  updateLeafletMapInstance(state: IGlobalState, payload: Map): void {
    state.leafletMapInstance = payload;
  },
  updateParkingsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingLayer = payload;
  },
  updateParkingZonesLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingZones = payload;
  },
  updateParkingZonesMarkersLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingZonesMarkers = payload;
  },
  updateParkingMetersLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingMeters = payload;
  },
  updateParkingBoardsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingBoards = payload;
  },
  updateParkingSpotsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingSpots = payload;
  },
  updateParkingGroupsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.parkingGroups = payload;
  },
  updateTrafficLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.trafficLayer = payload;
  },
  updateTrafficPointsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.trafficPointsLayer = payload;
  },
  updateEventsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.events = payload;
  },
  updateWeatherStationsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.weatherStations = payload;
  },
  updateBikeStationsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.bikeStations = payload;
  },
  updateVmsBoardsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.vmsBoards = payload;
  },
  updateCctvFixedCamerasLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.cctvFixedCameras = payload;
  },
  updateCctvPtzCamerasLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.cctvPtzCameras = payload;
  },
  updatePoiPointsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.poiPointsLayer = payload;
  },
  updateTrackStartPointsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.trackStartPointsLayer = payload;
  },
  updateTrackEndPointsLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.trackEndPointsLayer = payload;
  },
  updateTrackLinesLayerGroup(state: IGlobalState, payload: LayerGroup): void {
    state.leafletLayers.trackLinesLayer = payload;
  },
  updateLinks(state: IGlobalState, payload: Array<ILinkElement>): void {
    state.links = payload;
  },
  updateArticles(state: IGlobalState, payload: Array<IArticleElement>): void {
    state.articles = payload;
  },
  // obsługa modali
  displayModal(state: IGlobalState, payload: IModalData) {
    state.modal.data = payload;
    state.modal.display = true;
  },
  closeModal(state: IGlobalState) {
    state.modal.display = false;
  },
  openEventListModal(state: IGlobalState) {
    state.otherModals.eventListModal.display = true;
  },
  closeEventListModal(state: IGlobalState) {
    state.otherModals.eventListModal.display = false;
  },
  openOpenWeatherModal(state: IGlobalState) {
    state.otherModals.openWeatherModal.display = true;
  },
  closeOpenWeatherModal(state: IGlobalState) {
    state.otherModals.openWeatherModal.display = false;
  },
   openInfoModal(state: IGlobalState, payload: {name: string, description: string}) {
    state.otherModals.infoModal.data = payload;
    state.otherModals.infoModal.display = true;
  },
  closeInfoModal(state: IGlobalState) {
    state.otherModals.infoModal.display = false;
  },
  openStartModal(state: IGlobalState) {
    state.otherModals.startModal.display = true;
  },
  closeStartModal(state: IGlobalState) {
    state.otherModals.startModal.display = false;
  },
  // flagi wyświetlania warstw
  switchOffSelectedStartPoint(state: IGlobalState): void {
    state.tracks.isSelectedStartPoint = false;
  },
  switchOnSelectedStartPoint(state: IGlobalState): void {
    state.tracks.isSelectedStartPoint = true;
  },
  setSelectedStartPointId(state: IGlobalState, id: number): void {
    state.tracks.selectedStartPointId = id;
  },
  resetSelectedStartPointId(state: IGlobalState): void {
    state.tracks.selectedStartPointId = 0;
  },
  
  // set last request time to API
  setLastUpdateParkings(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkings = payload;
  },
  setLastUpdateParkingSpots(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkingSpots = payload;
  },
  setLastUpdateParkingGroups(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkingGroups = payload;
  },
  setLastUpdateParkingZones(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkingZones = payload;
  },
  setLastUpdateParkingMeters(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkingMeters = payload;
  },
  setLastUpdateParkingBoards(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateParkingBoards = payload;
  },
  setLastUpdateTraffic(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateTraffic = payload;
  },
  setLastUpdateTrafficPoints(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateTrafficPoints = payload;
  },
  setLastUpdateEvents(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateEvents = payload;
  },
  setLastUpdateVmsBoards(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateVmsBoards = payload;
  },
  setLastUpdateWeatherStations(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateWeatherStations = payload;
  },
  setLastUpdateBikeStations(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateBikeStations = payload;
  },
  setLastUpdateCameras(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateCameras = payload;
  },
  setLastUpdatePoiLayers(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdatePoiLayers = payload;
  },
  setLastUpdatePoiPoints(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdatePoiPoints = payload;
  },
  setLastUpdateOpenWeather(state: IGlobalState, payload: number): void {
    state.requestsToApi.lastUpdateOpenWeather = payload;
  },
  setSelectedParkingCode(state: IGlobalState, payload: string): void {
    state.selectedParkingCode = payload;
  },
  clearSelectedParkingCode(state: IGlobalState): void {
    state.selectedParkingCode = '';
  },
  setSelectedTrafficLineCode(state: IGlobalState, payload: number): void {
    state.selectedTrafficLineCode = payload;
  },
  clearSelectedTrafficLineCode(state: IGlobalState): void {
    state.selectedTrafficLineCode = null;
  },
  // for new API
  setSettingsParams(state: IGlobalState, payload: any): void {
    state.settings.staticParams = payload;
  },
  setSettingsMap(state: IGlobalState, payload: any): void {
    const localStateKeys = Object.keys(state.settings.map).map((key) => {
      return key;
    });
    const apiStateKeys = Object.keys(payload).map((key) => {
      return key;
    });
    // override if API returned other codes than in current state
    if (JSON.stringify(localStateKeys) != JSON.stringify(apiStateKeys)) {
      state.settings.map = payload;
    }
  },
  setSettingsMapPoiLayers(state: IGlobalState, payload: any): void {
    const localStatePoiPointsCodes = Object.keys(state.settings.mapPoiLayers).map((key) => {
      return key;
    });

    const apiStatePoiPointsCodes = Object.keys(payload).map((key) => {
      return key;
    });
    // // override if API returned other codes than in current state
    if (JSON.stringify(localStatePoiPointsCodes) != JSON.stringify(apiStatePoiPointsCodes)) {
      if (!state.settings.map.showPoi) {
        // set false for all categories 
        state.settings.mapPoiLayers = Object.fromEntries(
          Object.keys(payload).map(key => [key, false])
        );
      } else {         
        state.settings.mapPoiLayers = payload;
      } 
    }
  },
  setSettingsMapEventLayers(state: IGlobalState, payload: any): void {
    const localStateEventLayerCodes = Object.keys(state.settings.mapEventLayers).map((key) => {
      return key;
    });

    const apiStateEventLayerCodes = Object.keys(payload).map((key) => {
      return key;
    });
    // // override if API returned other codes than in current state
    if (JSON.stringify(localStateEventLayerCodes) != JSON.stringify(apiStateEventLayerCodes)) {
      if (!state.settings.map.showTraffic) {
        // set false for all categories 
        state.settings.mapEventLayers = Object.fromEntries(
          Object.keys(payload).map(key => [key, false])
        );
      } else {         
        state.settings.mapEventLayers = payload;
      } 
    }
  },
  enableLayer(state: IGlobalState, layerHandleName: string): void {
    if (layerHandleName in state.settings.map) {
      state.settings.map[layerHandleName] = true;
    }
  },
  disableLayer(state: IGlobalState, layerHandleName: string): void {
    if (layerHandleName in state.settings.map) {
      state.settings.map[layerHandleName] = false;
    }
  },
  enablePoiCategoryLayer(state: IGlobalState, key: string): void {
    if (key in state.settings.mapPoiLayers) {
      state.settings.mapPoiLayers[key] = true;
    }
  },
  disablePoiCategoryLayer(state: IGlobalState, key: string): void {
    if (key in state.settings.mapPoiLayers) {
      state.settings.mapPoiLayers[key] = false;
    }
  },
  enableEventCategoryLayer(state: IGlobalState, key: string): void {
    if (key in state.settings.mapEventLayers) {
      state.settings.mapEventLayers[key] = true;
    }
  },
  disableEventCategoryLayer(state: IGlobalState, key: string): void {
    if (key in state.settings.mapEventLayers) {
      state.settings.mapEventLayers[key] = false;
    }
  },
  enablePoiLayers(state: IGlobalState): void {
    const poiLayers = state.settings.mapPoiLayers;
    
    Object.keys(poiLayers).forEach((item: any) => {
      state.settings.mapPoiLayers[item] = true;
    });
  },
  disablePoiLayers(state: IGlobalState): void {
    const poiLayers = state.settings.mapPoiLayers;

    Object.keys(poiLayers).forEach((item: any) => {
      state.settings.mapPoiLayers[item] = false;
    });
  },
  enableEventLayers(state: IGlobalState): void {
    const eventLayers = state.settings.mapEventLayers;
    
    Object.keys(eventLayers).forEach((item: any) => {
      state.settings.mapEventLayers[item] = true;
    });
  },
  disableEventLayers(state: IGlobalState): void {
    const eventLayers = state.settings.mapEventLayers;

    Object.keys(eventLayers).forEach((item: any) => {
      state.settings.mapEventLayers[item] = false;
    });
  },
};
